import { Action, ActionProps } from '../02-atoms/Action';

export interface ActionsProps {
  /** Action objects */
  items: ActionProps[];
  /** Additional class */
  className?: string;
}

/** List of actions */
export const Actions = ({ items, className, ...props }: ActionsProps) => {
  return (
    <ul className={['actions', className].join(' ')} {...props}>
      {items.map((item, i) => {
        return (
          <li key={i} className="actions__tag">
            <Action {...item} />
          </li>
        );
      })}
    </ul>
  );
};
